let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6RZT5")).then(() => parcelRequire('gmoh7'));